//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapMutations } from 'vuex';
import {
  api_GetAllClaimStatus,
  api_ClaimDailyHappyCoin,
  api_ClaimHalfHourlyHappyCoin,
  api_ClaimTimePeriodHappyCoin,
  api_ClaimConsecutiveReward,
  api_GetHappyCoinRewards,
  api_GetHappyCoinDetails,
  api_GetExchangeConfig,
  api_GetHappyCoinGameTurnoverSettings,
  api_ExchangeToBalance,
  api_ClaimWeeklyHappyCoin,
  api_ClaimMonthlyHappyCoin,
  getCurrentVipInfo,
} from '@/api';

export default {
  name: 'JollyBeans',

  props: {},
  data() {
    return {
      gameTypeTab: 'upgrade', // 'upgrade' | 'current'
      activeTab: 'current', // 'current' | 'my' | 'all'
      selectedGame: 'battle', // 'battle' | 'upgrade' | 'multiplayer'
      // VIP配置：从API获取或由 GetCurrentVipInfo 的 vipLevels 映射
      vipConfig: [],
      // GetCurrentVipInfo 返回的完整数据（含 currentVipLevel、currentExperience、currentHappyCoinBonusRate、vipLevels 等）
      vipInfo: null,
      // 当前经验值（优先 GetCurrentVipInfo.currentExperience）
      currentExp: 0,
      // vip-rights 右侧动态面板：'vip' 显示等级进度，'reward' 显示领取奖励
      vipRightPanel: '',
      // 领取奖励 Tab
      rewardTab: 'daily',
      dailyRewards: [
        {
          id: 1,
          name: '首次登陆奖',
          value: '100',
          status: '已达成',
          desc: '',
          extra: '',
          countdown: false,
        },
        {
          id: 3,
          name: '每日热门时间',
          value: '50',
          status: '倒计时04:34.55',
          desc: ': 16:00-16:30-17:00',
          extra: '每个时间段限领一次',
          countdown: true,
        },
        {
          id: 2,
          name: '在线奖励',
          value: '20',
          status: '',
          desc: '(每20分钟可领取一次 最高10次)',
          extra: '',
          countdown: false,
        },
      ],
      weeklyRewards: [
        {
          id: 1,
          name: '每周六登陆奖',
          value: '100',
          status: '已达成',
          desc: '16:00-16:30-17:00',
        },
      ],
      weeklyRewardLoading: false,
      monthlyRewardLoading: false,
      // 每周/每月奖励接口返回的业务提示（如 success:false 时的 msg）
      weeklyRewardMsg: '',
      monthlyRewardMsg: '',
      monthlyPoints: [
        { time: '15:00', value: '100', position: 0 },
        { time: '16:00', value: '150', position: 25 },
        { time: '17:00', value: '200', position: 50 },
        { time: '18:00', value: '240', position: 75 },
        { time: '19:00', value: '300', position: 100 },
      ],
      monthlyClaimInfo: '',
      monthlyClaimDay: 15,
      // 兑换欢乐豆弹框（配置由 GetExchangeConfig 接口返回）
      showRedeemModal: false,
      exchangeConfig: null,
      exchangeConfigLoading: false,
      // 四款游戏的欢乐豆流水配置；缺省按累计流水处理
      gameTurnoverSettings: {
        crash: true,
        wheel: true,
        chickenRoad: true,
        poggi: true,
      },
      gameTurnoverSettingsRequest: null,
      showGameTurnoverModal: false,
      pendingGameRoute: null,
      // 游戏记录/余额记录 面板（PC 端）
      showRecordsView: false,
      recordTab: 'game', // 'game' | 'balance'
      gameTypeFilter: 'slot',
      manufacturerFilter: 'm1',
      gameTypeFilters: [
        { label: '全部', value: 'all' },
        { label: '老虎机', value: 'slot' },
        { label: 'CSGO', value: 'csgo' },
      ],
      manufacturerFilters: [
        { label: '厂家1', value: 'm1' },
        { label: '厂家2', value: 'm2' },
      ],
      gameRecords: [],
      gameRecordsPageIndex: 1,
      gameRecordsPageSize: 20,
      gameRecordsHasMore: true,
      gameRecordsLoading: false,
      gameRecordsFirstLoad: true,
      balanceRecords: [],
      balanceRecordsPageIndex: 1,
      balanceRecordsPageSize: 20,
      balanceRecordsHasMore: true,
      balanceRecordsLoading: false,
      balanceRecordsFirstLoad: true,
      // 连续登陆奖励：接口返回，默认占位
      consecutiveLoginList: [
        { day: 1, reward: 50 },
        { day: 2, reward: 60 },
        { day: 3, reward: 70 },
        { day: 4, reward: 80 },
        { day: 5, reward: 100 },
        { day: 6, reward: 120 },
        { day: 7, reward: 200 },
      ],
      consecutiveClaimDay: 5,
      consecutiveClaimAmount: 0,
      consecutiveProgressDays: 0,
      consecutiveCanClaim: false,
      consecutiveClaimed: false,
      happyCoinBalance: 0,
      claimVipLevel: 0,

      dailyClaimed: false,
      // 每日热门时间：当前时段结束时间（用于倒计时）
      timePeriodCountdownEnd: null,
      timePeriodCountdownText: '',
      timePeriodCountdownTimer: null,
      gameList: [
        {
          name: "Wheel",
          flag: 'happy_coin_wheel',
          src: require('@/assets/images/home_new/wheel.png'),
          route: { name: 'happyCoinWheel' },
        },
        {
          name: "POGGI",
          flag: 'happy_coin_poggi',
          src: require('@/assets/images/home_new/poggi.png'),
          route: { name: 'happyCoinPoggi' },
        },
        {
          name: "CHICKEN ROAD",
          flag: 'happy_coin_chicken',
          src: require('@/assets/images/home_new/cr.png'),
          route: { name: 'happyCoinChickenRoad' },
        },
        {
          name: "CRASH",
          flag: 'happy_coin_crash',
          src: require('@/assets/images/home_new/crash.png'),
          route: { name: 'happyCoinCrash' },
        },

        {
          name: "盲盒对战",
          flag: 'happy_coin_battle',
          src: require('@/assets/images/home_new/battle.png'),
          route: { name: 'happyCoinBattle' },
        },
        {
          name: "盲盒开箱",
          flag: 'happy_coin_box',
          src: require('@/assets/images/home_new/case.png'),
          route: { name: 'happyCoinBox' },
        },
        {
          name: "饰品升级",
          flag: 'happy_coin_upgrade',
          src: require('@/assets/images/home_new/upgrade.png'),
          route: { name: 'happyCoinUpgrade' },
        },
      ]
    };
  },
  computed: {
    ...mapState(['user']),
    isMobile() {
      return this.$screen && this.$screen.mobile;
    },

    consecutiveAmount() {
      return this.consecutiveClaimAmount;
    },
    // subSection5 每日领取金额：daily.reward.totalAmount
    dailyRewardAmount() {
      return this.dailyRewards[0]?.value ?? '0';
    },
    // 每日是否已领取：daily.claimed
    // dailyClaimed() {
    //   console.log(!!this.dailyRewards[0]?.claimed);
    //   return !!this.dailyRewards[0]?.claimed;
    // },
    // 当前VIP等级（优先 GetCurrentVipInfo.currentVipLevel，其次 GetAllClaimStatus.claimVipLevel）
    currentVipLevel() {
      if (this.vipInfo != null && this.vipInfo.currentVipLevel != null)
        return this.vipInfo.currentVipLevel;
      if (this.claimVipLevel != null && this.claimVipLevel > 0)
        return this.claimVipLevel;
      return this.user?.vipLevel ?? 0;
    },
    // 当前加成百分比：取 GetCurrentVipInfo.currentHappyCoinBonusRate * 100
    currentBoostPercent() {
      if (this.vipInfo != null && this.vipInfo.currentHappyCoinBonusRate != null)
        return Math.round(this.vipInfo.currentHappyCoinBonusRate * 100);
      if (!this.vipConfig || this.vipConfig.length === 0) return 0;
      const currentVip = this.vipConfig.find(
        (vip) => vip.level === this.currentVipLevel,
      );
      return currentVip?.boost ?? 0;
    },
    // 最大经验值（用于进度条，取 vipLevels 最后一级的 requiredExperience）
    maxExp() {
      if (this.vipInfo?.vipLevels?.length) {
        const last = this.vipInfo.vipLevels[this.vipInfo.vipLevels.length - 1];
        return Number(last?.requiredExperience) || 0;
      }
      if (!this.vipConfig || this.vipConfig.length === 0) return 50000;
      const maxLevel = Math.max(...this.vipConfig.map((vip) => vip.level));
      const maxVip = this.vipConfig.find((vip) => vip.level === maxLevel);
      return maxVip?.exp || 50000;
    },
    // VIP标记点配置：只展示 5 个等级，等间距、首尾内收防溢出
    vipMarkers() {
      const levels = this.vipInfo?.vipLevels;
      if (levels && levels.length > 0) {
        const total = levels.length;
        // 固定展示 5 个点，间距更大；位置 8%～92% 避免两边溢出
        const count = 5;
        const indices = [];
        if (total <= count) {
          for (let i = 0; i < total; i++) indices.push(i);
        } else {
          indices.push(0);
          for (let k = 1; k < count - 1; k++) {
            const i = Math.round((k / (count - 1)) * (total - 1));
            indices.push(i);
          }
          indices.push(total - 1);
        }
        const n = indices.length;
        const startPos = 8;
        const endPos = 92;
        return indices.map((idx, i) => {
          const row = levels[idx];
          const rate = row?.happyCoinBonusRate;
          const position =
            n <= 1 ? startPos : startPos + (i / (n - 1)) * (endPos - startPos);
          return {
            level: row?.level ?? idx,
            boost: rate != null ? Math.round(rate * 100) : null,
            position,
          };
        });
      }
      return [
        { level: 0, boost: 0, position: 8 },
        { level: 5, boost: 50, position: 29 },
        { level: 10, boost: 100, position: 50 },
        { level: 15, boost: 150, position: 71 },
        { level: 20, boost: 200, position: 92 },
      ];
    },
    // 连续登陆进度条百分比：已连续天数 + 一点点（优先用接口返回的 consecutiveProgressDays）
    continuousLoginProgressPercent() {
      const total = this.consecutiveLoginList?.length || 7;
      const days = Number(this.consecutiveProgressDays) || 0;
      if (total <= 0) return 0;
      const base = (days / total) * 100;
      const aBit = total > 0 ? (100 / total) * 0.25 : 2;
      return Math.min(base + aBit, 100);
    },
    // 进度条填充百分比（当前经验 / 最大经验）
    progressPercentage() {
      if (this.vipInfo != null && this.maxExp > 0)
        return Math.min(
          100,
          Math.max(0, (this.currentExp / this.maxExp) * 100),
        );
      return 0;
    },
    // 经验值工具提示位置（0～100% 对应进度）
    expTooltipPosition() {
      if (this.vipInfo != null && this.maxExp > 0)
        return Math.min(
          100,
          Math.max(0, (this.currentExp / this.maxExp) * 100),
        );
      return 0;
    },
    // 经验值工具提示显示位置（限制在 8%～92% 防溢出）
    expTooltipPositionClamped() {
      const p = this.expTooltipPosition;
      return Math.max(8, Math.min(92, p));
    },
    // 兑换弹框说明文案（来自 GetExchangeConfig）
    redeemDesc() {
      const c = this.exchangeConfig;
      if (!c) return '加载中...';
      return `根据欢乐豆游戏战力兑换额度：欢乐豆打出的战力加上一定数量欢乐豆才可以兑换。兑换比例1:(${this.formatExchangeDisplay(c.exchangeRate)}战力 + ${this.formatExchangeDisplay(c.exchangeRateExtraHappyCoin)} 欢乐豆)。`;
    },
    // 兑换弹框列表项：previewExchange.minBalance / maxBalance 对应两个兑换条件，结合 exchangeRate 与当前战力 totalHappyCoinTurnover 判断是否满足
    redeemItems() {
      const c = this.exchangeConfig;
      if (!c || !c.previewExchange) return [];
      const rate = Number(c.exchangeRate) || 100;
      const turnover = Number(c.totalHappyCoinTurnover) || 0;
      const prev = c.previewExchange;
      const minRequired = Number(prev.minHappyCoin) || 0;
      const maxRequired = Number(prev.maxHappyCoin) || 0;
      return [
        {
          id: 1,
          condition: this.formatExchangeDisplay(c.exchangeRate),
          quota: this.formatExchangeDisplay(prev.maxBalance < 1 ? 0 : prev.maxBalance),
          exchangeRate: rate,
          currentTurnover: this.formatExchangeDisplay(c.totalHappyCoinTurnover - c.usedHappyCoinTurnover),
          claimable: turnover >= c.exchangeMinTurnoverAmount,
        }
      ];
    },
  },
  mounted() {
    this.getAllClaimStatus();
    this.getConsecutiveRewardConfig();
    this.initVipData();
    this.fetchCurrentVipInfo();
    this.loadGameTurnoverSettings();
  },
  beforeDestroy() {
    this.clearTimePeriodCountdown();
  },
  watch: {
    // 监听user变化，更新当前经验值（有 vipInfo 时以 vipInfo.currentExperience 为准）
    user: {
      handler(newUser) {
        if (this.vipInfo != null) {
          this.currentExp = Number(this.vipInfo.currentExperience) || 0;
          return;
        }
        if (newUser) {
          this.currentExp =
            newUser.experience || newUser.exp || newUser.currentExp || 0;
        }
      },
      immediate: true,
      deep: true,
    },
    recordTab(val) {
      if (val === 'game' && this.showRecordsView) {
        this.$nextTick(() => this.fetchGameRecords(false));
      }
      if (val === 'balance' && this.showRecordsView) {
        this.$nextTick(() => this.fetchBalanceRecords(false));
      }
    },
    // 每周/每月配置来自 getAllClaimStatus，切换 tab 不再请求领取接口
  },
  methods: {
    ...mapMutations(['setInfo']),
    handleGameTypeTabClick(tab) {
      // 游戏类型 tab 切换事件
      this.gameTypeTab = tab.name;
      // 这里可以添加切换游戏类型后的逻辑，比如加载不同的数据
      console.log('切换到游戏类型:', tab.name);
    },
    async goToGame(route) {
      const settingNameByRoute = {
        happyCoinCrash: 'crash',
        happyCoinWheel: 'wheel',
        happyCoinChickenRoad: 'chickenRoad',
        happyCoinPoggi: 'poggi',
      };
      const settingName = settingNameByRoute[route?.name];
      if (settingName) {
        await this.loadGameTurnoverSettings();
        if (this.gameTurnoverSettings[settingName] === false) {
          this.pendingGameRoute = route;
          this.showGameTurnoverModal = true;
          return;
        }
      }
      this.navigateToGame(route);
    },
    async loadGameTurnoverSettings() {
      if (this.gameTurnoverSettingsRequest) return this.gameTurnoverSettingsRequest;

      this.gameTurnoverSettingsRequest = api_GetHappyCoinGameTurnoverSettings()
        .then((res) => {
          const ok = res?.data?.success === true || res?.data?.code === 0;
          const data = res?.data?.data ?? res?.data;
          if (!ok || !data || typeof data !== 'object') return;

          Object.keys(this.gameTurnoverSettings).forEach((key) => {
            const value = data[key];
            if (typeof value === 'boolean') {
              this.gameTurnoverSettings[key] = value;
            } else if (typeof value === 'number') {
              this.gameTurnoverSettings[key] = value !== 0;
            } else if (typeof value === 'string') {
              this.gameTurnoverSettings[key] = !['false', '0', 'off', 'no'].includes(value.trim().toLowerCase());
            }
          });
        })
        .catch((error) => {
          console.warn('获取欢乐豆游戏流水配置失败，按累计流水处理', error);
        })
        .finally(() => {
          this.gameTurnoverSettingsRequest = null;
        });

      return this.gameTurnoverSettingsRequest;
    },
    navigateToGame(route) {
      const query = { ...(route.query || {}) };
      delete query.uhc;
      delete query.currencyType;
      this.$router.push({ ...route, query });
    },
    closeGameTurnoverModal() {
      this.showGameTurnoverModal = false;
      this.pendingGameRoute = null;
    },
    enterPendingGame() {
      const route = this.pendingGameRoute;
      this.closeGameTurnoverModal();
      if (route) this.navigateToGame(route);
    },
    handleTabClick(tab) {
      // el-tabs 的 tab-click 事件回调
      this.activeTab = tab.name;
      // 这里可以添加切换tab后的逻辑，比如加载不同的数据
      console.log('切换到:', tab.name);
    },
    selectGame(game) {
      // 切换选中的游戏
      this.selectedGame = game;
      console.log('切换到游戏:', game);
    },
    handleView() {
      // 查看按钮的点击事件
      console.log('点击查看');
    },
    async handleClaimDailyHappyCoin() {
      if (this.dailyClaimed) {
        this.$toast?.('已领取');
        return;
      }
      try {
        const res = await api_ClaimDailyHappyCoin();
        if (res.data.code === 0) {
          this.$toast.success('领取成功');
          this.setInfo();
          this.dailyRewards[0] = {
            ...this.dailyRewards[0],
            claimed: true,
            status: '已领取',
            canClaim: false,
          };
          this.dailyClaimed = true;
          this.getAllClaimStatus();
        } else {
          this.$toast.error(res.data.msg || '领取失败');
        }
      } catch (error) {
        console.error('领取欢乐豆失败:', error);
        this.$toast.error('领取失败，请稍后重试');
      }
    },
    async handleClaimReward(item) {
      if (!item || !item.type) return;
      const type = item.type;
      let res;
      try {
        if (type === 'daily') {
          res = await api_ClaimDailyHappyCoin();
        } else if (type === 'halfHourly') {
          res = await api_ClaimHalfHourlyHappyCoin();
        } else if (type === 'timePeriod') {
          res = await api_ClaimTimePeriodHappyCoin();
        } else if (type === 'weekly') {
          res = await api_ClaimWeeklyHappyCoin();
        } else {
          return;
        }
        const ok = res?.data?.success === true || res?.data?.code === 0;
        if (ok) {
          this.$toast?.success?.(res?.data?.msg || '领取成功');
          this.setInfo();
          await this.getAllClaimStatus();
        } else {
          this.$toast?.error?.(res?.data?.msg || '领取失败');
        }
      } catch (e) {
        console.error('领取奖励失败:', e);
        this.$toast?.error?.('领取失败，请稍后重试');
      }
    },
    async handleClaimMonthly() {
      try {
        const res = await api_ClaimMonthlyHappyCoin();
        const ok = res?.data?.success === true || res?.data?.code === 0;
        if (ok) {
          this.$toast?.success?.(res?.data?.msg || '领取成功');
          this.setInfo();
          await this.getAllClaimStatus();
        } else {
          this.$toast?.error?.(res?.data?.msg || '领取失败');
        }
      } catch (e) {
        console.error('领取每月奖励失败:', e);
        this.$toast?.error?.('领取失败，请稍后重试');
      }
    },
    async openRedeemModal() {
      this.showRedeemModal = true;
      this.exchangeConfigLoading = true;
      this.exchangeConfig = null;
      try {
        const res = await api_GetExchangeConfig();
        const ok = res?.data?.success === true || res?.data?.code === 0;
        const data = res?.data?.data ?? res?.data;
        this.exchangeConfig = ok && data && typeof data === 'object' ? data : null;
      } catch (e) {
        this.exchangeConfig = null;
      }
      this.exchangeConfigLoading = false;
    },
    formatExchangeDisplay(v) {
      if (v == null || v === '') return '0';
      const n = Number(v);
      if (Number.isNaN(n)) return String(v);
      if (Number.isInteger(n)) return String(n);
      const s = n.toFixed(2);
      return s.replace(/\.?0+$/, '') || '0';
    },
    async handleRedeem(item) {
      const amount = Number(item.condition);
      if (Number.isNaN(amount)) {
        this.$toast?.error?.('兑换参数无效') || console.warn('invalid amount', item.condition);
        return;
      }
      try {
        const res = await api_ExchangeToBalance({ amount });
        const data = res?.data;
        const ok = data?.success === true || data?.code === 0;
        const msg = data?.msg ?? data?.message ?? (ok ? '兑换成功' : '兑换失败');
        if (ok) {
          this.$toast?.success?.(msg) || this.$message?.success?.(msg) || console.log(msg);
          this.setInfo();
          try {
            const r = await api_GetExchangeConfig();
            const cfgOk = r?.data?.success === true || r?.data?.code === 0;
            const cfg = r?.data?.data ?? r?.data;
            if (cfgOk && cfg && typeof cfg === 'object') this.exchangeConfig = cfg;
          } catch (_) { }
        } else {
          this.$toast?.error?.(msg) || this.$message?.error?.(msg) || console.warn(msg);
        }
      } catch (e) {
        const errMsg = e?.response?.data?.msg ?? e?.response?.data?.message ?? e?.message ?? '兑换失败';
        this.$toast?.error?.(errMsg) || this.$message?.error?.(errMsg) || console.warn(errMsg);
      }
    },
    openRecordsView(tab) {
      this.showRecordsView = true;
      this.recordTab = tab;
      if (tab === 'game') {
        this.$nextTick(() => this.fetchGameRecords(false));
      }
      if (tab === 'balance') {
        this.$nextTick(() => this.fetchBalanceRecords(false));
      }
    },
    async fetchGameRecords(append = false) {
      if (this.gameRecordsLoading) return;
      if (append && !this.gameRecordsHasMore) return;
      this.gameRecordsLoading = true;
      const pageIndex = append ? this.gameRecordsPageIndex : 1;
      try {
        const res = await api_GetHappyCoinRewards({
          pageIndex,
          pageSize: this.gameRecordsPageSize,
        });
        const ok = res?.data?.code === 0 || res?.data?.success === true;
        const data = res?.data?.data ?? res?.data;
        const list = data?.details ?? data?.list ?? data?.items ?? data?.records ?? (Array.isArray(data) ? data : []);
        const rows = Array.isArray(list) ? list.map((item, i) => this.mapGameRecordItem(item, append ? this.gameRecords.length + i : i)) : [];
        if (!append) {
          this.gameRecords = rows;
          this.gameRecordsPageIndex = 1;
          this.gameRecordsFirstLoad = false;
        } else {
          this.gameRecords = this.gameRecords.concat(rows);
        }
        const total = data?.totalCount ?? data?.total ?? 0;
        this.gameRecordsHasMore =
          rows.length >= this.gameRecordsPageSize && (total === 0 || (append ? this.gameRecords.length : rows.length) < total);
        if (!append) this.gameRecordsPageIndex = 2;
        else this.gameRecordsPageIndex = pageIndex + 1;
      } catch (e) {
        console.error('获取游戏记录失败', e);
        if (!append) this.gameRecordsFirstLoad = true;
      } finally {
        this.gameRecordsLoading = false;
      }
    },
    mapGameRecordItem(item, fallbackId) {
      return {
        id: item.id ?? item.recordId ?? fallbackId,
        gameName: item.gameName ?? item.game_name ?? item.game ?? '—',
        gameId: item.gameId ?? item.game_id ?? item.id ?? '—',
        betTime: item.betTime ?? item.bet_time ?? item.createTime ?? '—',
        betAmount: item.betAmount ?? item.bet_amount ?? item.totalCost ?? '0',
        validAmount: item.validAmount ?? item.valid_amount ?? item.validBet ?? '0',
        profit: item.profit ?? item.winAmount ?? item.win_amount ?? '0',
      };
    },
    onRecordsGameListScroll(e) {
      const el = e?.target || this.$refs.recordsGameListScroll;
      if (!el || this.gameRecordsLoading || !this.gameRecordsHasMore || this.gameRecords.length === 0) return;
      const { scrollTop, scrollHeight, clientHeight } = el;
      const threshold = 80;
      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        this.fetchGameRecords(true);
      }
    },
    async fetchBalanceRecords(append = false) {
      if (this.balanceRecordsLoading) return;
      if (append && !this.balanceRecordsHasMore) return;
      this.balanceRecordsLoading = true;
      const pageIndex = append ? this.balanceRecordsPageIndex : 1;
      try {
        const res = await api_GetHappyCoinDetails({
          pageIndex,
          pageSize: this.balanceRecordsPageSize,
        });
        const ok = res?.data?.code === 0 || res?.data?.success === true;
        const data = res?.data?.data ?? res?.data;
        const list = data?.details ?? data?.list ?? data?.items ?? data?.records ?? (Array.isArray(data) ? data : []);
        const rows = Array.isArray(list) ? list.map((item, i) => this.mapBalanceRecordItem(item, append ? this.balanceRecords.length + i : i)) : [];
        if (!append) {
          this.balanceRecords = rows;
          this.balanceRecordsPageIndex = 1;
          this.balanceRecordsFirstLoad = false;
        } else {
          this.balanceRecords = this.balanceRecords.concat(rows);
        }
        const total = data?.totalCount ?? data?.total ?? 0;
        this.balanceRecordsHasMore =
          rows.length >= this.balanceRecordsPageSize && (total === 0 || (append ? this.balanceRecords.length : rows.length) < total);
        if (!append) this.balanceRecordsPageIndex = 2;
        else this.balanceRecordsPageIndex = pageIndex + 1;
      } catch (e) {
        console.error('获取余额记录失败', e);
        if (!append) this.balanceRecordsFirstLoad = true;
      } finally {
        this.balanceRecordsLoading = false;
      }
    },
    mapBalanceRecordItem(item, fallbackId) {
      return {
        id: item.id ?? item.recordId ?? fallbackId,
        detail: item.detail ?? item.description ?? item.description ?? '—',
        transactionId: item.transactionId ?? item.transaction_id ?? item.sn ?? '—',
        game: item.game ?? item.gameName ?? item.game_name ?? '—',
        profit: item.amount ?? 0,
        flow: String(item.amount ?? '0'),
        balance: String(item.balance ?? item.afterBalance ?? item.after_balance ?? '0'),
        time: item.time ?? item.createTime ?? item.create_time ?? item.betTime ?? '—',
      };
    },
    onRecordsBalanceListScroll(e) {
      const el = e?.target || this.$refs.recordsBalanceListScroll;
      if (!el || this.balanceRecordsLoading || !this.balanceRecordsHasMore || this.balanceRecords.length === 0) return;
      const { scrollTop, scrollHeight, clientHeight } = el;
      const threshold = 80;
      if (scrollTop + clientHeight >= scrollHeight - threshold) {
        this.fetchBalanceRecords(true);
      }
    },
    getContinuousPointLeft(i) {
      const total = this.consecutiveLoginList?.length || 7;
      if (total <= 1) return 50;
      if (i === 0) return 2;
      if (i === total - 1) return 95;
      if (i === total - 2) return 81.3333;
      const step = (81.3333 - 2) / (total - 2);
      return Math.round((2 + step * i) * 10000) / 10000;
    },
    clearTimePeriodCountdown() {
      if (this.timePeriodCountdownTimer != null) {
        clearInterval(this.timePeriodCountdownTimer);
        this.timePeriodCountdownTimer = null;
      }
      this.timePeriodCountdownEnd = null;
      this.timePeriodCountdownText = '';
    },
    /** 根据 startTime "HH:mm" 计算下次出现时间（支持跨天） */
    getNextStartTimeMs(startTimeStr) {
      if (!startTimeStr || typeof startTimeStr !== 'string') return null;
      const parts = startTimeStr.trim().split(':');
      const h = parseInt(parts[0], 10) || 0;
      const m = parseInt(parts[1], 10) || 0;
      const now = new Date();
      const target = new Date(now.getFullYear(), now.getMonth(), now.getDate(), h, m, 0, 0);
      if (target.getTime() <= Date.now()) {
        target.setDate(target.getDate() + 1);
      }
      return target.getTime();
    },
    startTimePeriodCountdown(startTimeStr) {
      const targetMs = this.getNextStartTimeMs(startTimeStr);
      if (!targetMs || targetMs <= Date.now()) {
        this.timePeriodCountdownText = '';
        return;
      }
      this.timePeriodCountdownEnd = targetMs;
      const tick = () => {
        const diff = this.timePeriodCountdownEnd - Date.now();
        if (diff <= 0) {
          this.clearTimePeriodCountdown();
          this.getAllClaimStatus();
          return;
        }
        const totalSec = Math.floor(diff / 1000);
        const hh = Math.floor(totalSec / 3600);
        const mm = Math.floor((totalSec % 3600) / 60);
        const ss = totalSec % 60;
        this.timePeriodCountdownText = [hh, mm, ss]
          .map((n) => String(n).padStart(2, '0'))
          .join(':');
      };
      tick();
      this.timePeriodCountdownTimer = setInterval(tick, 1000);
    },
    async getAllClaimStatus() {
      try {
        const res = await api_GetAllClaimStatus();
        const ok = res?.data?.success === true || res?.data?.code === 0;
        const data = res?.data?.data ?? res?.data;
        if (!ok || !data) return;
        if (data.currentBalance != null)
          this.happyCoinBalance = data.currentBalance;
        if (data.vipLevel != null) this.claimVipLevel = data.vipLevel;
        if (data.daily) {
          const d = data.daily;
          const r = d.reward ?? {};
          const amount = r.totalAmount ?? r.baseAmount ?? 0;
          this.dailyRewards[0] = {
            id: 1,
            name: '首次登陆奖',
            value: String(amount),
            status: d.claimed ? '已领取' : d.canClaim ? '可领取' : '未达成',
            desc: '',
            extra: '',
            countdown: false,
            type: 'daily',
            canClaim: !!d.canClaim,
            claimed: !!d.claimed,
          };
          this.dailyClaimed = !!d.claimed;
          console.log(this.dailyRewards[0]);
        }
        if (data.halfHourly) {
          const h = data.halfHourly;
          const r = h.reward ?? {};
          const amount = r.totalAmount ?? r.baseAmount ?? 0;
          const interval = h.claimIntervalMinutes ?? 30;
          const maxTimes = h.maxClaimTimesPerDay ?? 10;
          const claimedTimes = h.claimedTimes ?? 0;
          this.dailyRewards[2] = {
            id: 2,
            name: '在线奖励',
            value: String(amount),
            status: h.canClaim ? '可领取' : `已领取${claimedTimes}次`,
            desc: `(每${interval}分钟可领取一次 最高${maxTimes}次)`,
            extra: '',
            countdown: false,
            type: 'halfHourly',
            canClaim: !!h.canClaim,
          };
        }
        if (data.timePeriod) {
          const tp = data.timePeriod;
          const periods = tp.timePeriods ?? [];
          const currentPeriod = tp.currentPeriod ?? null;
          const r = tp.reward ?? {};
          const amount = r.totalAmount ?? r.baseAmount ?? 0;
          const descRanges = periods.length
            ? periods.map((p) => p.timeRange).join('、')
            : '';
          const firstUnclaimed = periods.find((p) => !p.claimed);
          const needCountdown = !tp.canClaimNow && firstUnclaimed?.startTime;
          this.dailyRewards[1] = {
            id: 3,
            name: '每日热门时间',
            value: String(amount),
            status: tp.canClaimNow
              ? '可领取'
              : currentPeriod
                ? '当前时段可领'
                : '',
            desc: currentPeriod?.timeRange
              ? `当前时段: ${currentPeriod.timeRange}`
              : descRanges
                ? `: ${descRanges}`
                : '',
            extra: '每个时间段限领一次',
            countdown: needCountdown,
            type: 'timePeriod',
            canClaim: !!tp.canClaimNow,
          };
          this.clearTimePeriodCountdown();
          if (needCountdown && firstUnclaimed?.startTime) {
            this.startTimePeriodCountdown(firstUnclaimed.startTime);
          }
        }
        if (data.weekly) {
          const w = data.weekly;
          const r = w.reward ?? {};
          const amount = r.totalAmount ?? r.baseAmount ?? 0;
          const periods = w.timePeriods ?? [];
          const descRanges = periods.length ? periods.map((p) => p.timeRange).join('、') : '';
          const status = w.canClaimNow ? '可领取' : w.claimed ? '已领取' : (w.nextClaimTime ? `下次 ${w.nextClaimTime}` : '');
          this.weeklyRewardMsg = '';
          this.weeklyRewards = [
            {
              id: 1,
              name: `每周${w.claimDayName ?? '六'}奖励`,
              value: String(amount),
              desc: descRanges || '',
              status,
              type: 'weekly',
              canClaim: !!w.canClaimNow,
            },
          ];
          // 不单独展示「下次领取时间」提示卡，已在下方卡片 status 中展示
          this.weeklyRewardMsg = '';
        }
        if (data.monthly) {
          const m = data.monthly;
          const periods = m.timePeriods ?? [];
          const r = m.reward ?? {};
          const defaultAmount = r.totalAmount ?? r.baseAmount ?? 0;
          if (periods.length) {
            const points = periods.map((p, i) => ({
              time: p.startTime,
              value: String(
                (p.reward && (p.reward.totalAmount ?? p.reward.baseAmount)) ??
                defaultAmount,
              ),
              canClaim: !!p.canClaim,
            }));
            const last = periods[periods.length - 1];
            if (last && last.endTime && last.endTime !== last.startTime) {
              points.push({
                time: last.endTime,
                value: String(
                  (last.reward && (last.reward.totalAmount ?? last.reward.baseAmount)) ?? defaultAmount,
                ),
                canClaim: false,
              });
            }
            const total = points.length;
            this.monthlyPoints = points.map((p, i) => ({
              ...p,
              position: total > 1 ? (i / (total - 1)) * 100 : 50,
            }));
          }
          this.monthlyClaimInfo = m.canClaimNow ? '可领取' : (m.nextClaimTime ? `${m.nextClaimTime} 可领` : '');
          this.monthlyClaimDay = m.claimDayOfMonth != null ? m.claimDayOfMonth : 15;
          this.monthlyRewardMsg = '';
          if (!m.isClaimDay && !m.claimed && m.claimDayOfMonth != null) {
            this.monthlyRewardMsg = `每月${m.claimDayOfMonth}号可领取`;
          }
        }
        if (data.consecutive) {
          const c = data.consecutive;
          this.consecutiveCanClaim = !!c.canClaim;
          this.consecutiveClaimed = !!c.claimed;
          const allDayRewards = c.allDayRewards ?? [];
          if (Array.isArray(allDayRewards) && allDayRewards.length > 0) {
            this.consecutiveLoginList = allDayRewards.map((item, i) => ({
              day: item.day ?? item.day_index ?? i + 1,
              reward:
                item.totalAmount ??
                item.baseAmount ??
                item.reward ??
                item.amount ??
                item.value ??
                0,
            }));
          }
          const currentDay = c.currentDay ?? 1;
          this.consecutiveProgressDays = currentDay;
          this.consecutiveClaimDay = currentDay;
          const todayReward = c.todayReward ?? {};
          this.consecutiveClaimAmount =
            todayReward.totalAmount ??
            todayReward.baseAmount ??
            todayReward.reward ??
            0;
        }
      } catch (error) {
        console.error('获取欢乐豆领取状态失败:', error);
      }
    },
    // 连续登录奖励配置来自 GetAllClaimStatus 的 data.consecutive（allDayRewards/currentDay/todayReward/canClaim/claimed），不再单独请求
    getConsecutiveRewardConfig() { },
    // 连续登录领取：使用 GetAllClaimStatus 返回的 consecutive 状态，领取时调用 POST api/HappyCoin/ClaimConsecutiveReward
    async handleClaimConsecutiveHappyCoin() {
      if (this.consecutiveClaimed) {
        this.$toast?.('已领取');
        return;
      }
      try {
        const res = await api_ClaimConsecutiveReward();
        const ok = res?.data?.success === true || res?.data?.code === 0;
        if (ok) {
          this.$toast?.success?.(res?.data?.msg || '领取成功');
          this.setInfo();
          await this.getAllClaimStatus();
        } else {
          this.$toast?.error?.(res?.data?.msg || '领取失败');
        }
      } catch (error) {
        console.error('领取连续登录奖励失败:', error);
        this.$toast?.error?.('领取失败，请稍后重试');
      }
    },
    // 初始化VIP数据（仅在没有 vipInfo 时做兜底）
    initVipData() {
      if (this.vipInfo != null) return;
      this.vipConfig = [
        { level: 1, exp: 0, boost: 100 },
        { level: 3, exp: 2000, boost: 110 },
        { level: 5, exp: 5000, boost: 120 },
        { level: 10, exp: 15000, boost: 130 },
        { level: 13, exp: 50000, boost: 150 },
      ];
      if (this.user) {
        this.currentExp =
          this.user.experience || this.user.exp || this.user.currentExp || 0;
      }
    },
    // 进入页面获取当前VIP信息（GetCurrentVipInfo），驱动 %加成、vip-rights-panel 配置与当前经验
    async fetchCurrentVipInfo() {
      try {
        const res = await getCurrentVipInfo();
        if (res.data && res.data.code === 0 && res.data.data) {
          const data = res.data.data;
          this.vipInfo = data;
          // 配置：vipLevels 映射为 vipConfig 格式，供其它逻辑复用
          const levels = data.vipLevels || [];
          this.vipConfig = levels.map((row) => ({
            level: row.level,
            exp: Number(row.requiredExperience) || 0,
            boost: Math.round((row.happyCoinBonusRate ?? 0) * 100),
          }));
          // 当前经验值取 currentExperience
          this.currentExp = Number(data.currentExperience) || 0;
        }
      } catch (e) {
        console.error('GetCurrentVipInfo 请求失败:', e);
      }
    },
  },
};
